import styled from 'styled-components';

const StyledSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export { StyledSection };
